export default __webpack_public_path__ + "static/media/Digital_2_Pin_Output@2x.791bf07b.png";